// import AccountInventoryService from '@/services/accountinventory.service.js'
import ChangeLogService from '@/services/changelog.service.js'
import UserService from '@/services/user.service.js'

export default {
  switchView: (context) => {
    UserService.switchView()
  },
  showLogRecords: async (context, data) => {
    context.commit('showLogs', true)
    context.commit('setLoadingLogs', true)
    ChangeLogService.getById(data, (logs, err) => {
      if (err) {
        // context.commit('setCustomerList', customers)
      } else {
        context.commit('setLogRecords', logs)
      }
      context.commit('setLoadingLogs', false)
    })
  },
  showAllRecords: async (context, data) => {
    context.commit('showLogs', true)
    context.commit('setLoadingLogs', true)
    ChangeLogService.getAll((logs, err) => {
      if (err) {
        // context.commit('setCustomerList', customers)
      } else {
        context.commit('setLogRecords', logs)
      }
      context.commit('setLoadingLogs', false)
    })
  }
}
